const FieldTypes = {
  Text: 'text',
  HexColor: 'hexColor'
};

export default FieldTypes;
